import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { ExportDataRespons, ReportType } from '../../ExportDataRespons';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from 'src/app/models/user.model';
import { SelectedUsersComponent } from '../selected-users/selected-users.component';
import { Recipient } from 'src/app/models/recipients.model';
@Component({
    selector: 'que-export-report',
    imports: [CommonModule, OverlayModule, TranslateDirective, TranslatePipe, SelectedUsersComponent],
    templateUrl: './export-report.component.html',
    styleUrls: ['./export-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExportReportComponent {

  readonly positonArea = [{
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
  }] as ConnectedPosition[];
  eReportType = ReportType;
  selectedType = ReportType.CSV;
  isOpenType = false;
  isShowComparison = false;
  isComparison = false;
  users = [] as User[];
  selectedUsersIdes = [] as number[];
  constructor(
    @Inject(MAT_DIALOG_DATA)
    private data: { users: Recipient[], isShowComparison: boolean },
    private dialogRef: MatDialogRef<ExportReportComponent>,
  ) {
    if (data.users) {
      this.users = data.users.map(recip => { return { ...recip.user, id: recip.id } })
    }
    if (data.isShowComparison) {
      this.isShowComparison = data.isShowComparison;
    }
  }

  chooseType(type: ReportType) {
    this.selectedType = type;
    this.isOpenType = false;
    this.selectedUsersIdes = [];
    this.isComparison = false;
  }
  selectUsers(usersIdes: number[]) {
    this.selectedUsersIdes = usersIdes;
  }
  cancel() {
    this.dialogRef.close();
  }
  download() {
    this.dialogRef.close({
      reportType: this.selectedType,
      isComparison: this.isComparison,
      users: this.selectedUsersIdes
    } as ExportDataRespons);
  }
}
